import React from 'react';
import styled from 'styled-components';
import { INVOICE_STATUSES } from '../constants';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { invoiceSearch } from '../actions';
import { BaseComponent } from '../../../components/BaseComponent';

const PaidStatusContainer = styled.div`
  color: white;
  background-color: green;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 12px;
`;

const OpenStatusContainer = styled.div`
  color: white;
  background-color: black;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 12px;
`;

const CancelledStatusContainer = styled.div`
  color: white;
  background-color: red;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 12px;
`;

const getContainer = status => {
  switch (status) {
    case INVOICE_STATUSES.PAID:
      return PaidStatusContainer;

    case INVOICE_STATUSES.OPEN:
      return OpenStatusContainer;

    case INVOICE_STATUSES.CANCELLED:
      return CancelledStatusContainer;

    case INVOICE_STATUSES.CANCELLED_CONCEPT:
      return CancelledStatusContainer;

    case 'NULL':
      return CancelledStatusContainer;

    default:
      return OpenStatusContainer;
  }
};

const STATE = {};

class InvoiceStatusComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  render() {
    const Container = getContainer(this.props.status);
    return <Container {...this.props}>{this.lbl(`invoice.paid.${this.props.status}`)}</Container>;
  }
}

InvoiceStatusComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    search(string, callback) {
      dispatch(invoiceSearch(string, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoiceStatus = compose(withConnect, withRouter)(InvoiceStatusComp);
